module.exports = __webpack_public_path__ + "static/media/zola.75357cd3.gif";